import { api, unwrap } from '@/api'

export interface BillingOverviewData {
  subscription: any
  invoices: any[]
  billingHistory: any[]
}

export interface CheckoutResponse {
  subscription: any
  checkoutUrl?: string
  keyId: string
  amount: number
  currency: string
  razorpaySubscriptionId: string
}

export const billingService = {
  async getOverview(): Promise<BillingOverviewData> {
    const res = await api.get<BillingOverviewData>('/platform/billing/overview')
    return unwrap(res)
  },

  async initiateCheckout(planId: number, couponCode?: string): Promise<CheckoutResponse> {
    const res = await api.post<CheckoutResponse>('/platform/billing/checkout', { planId, couponCode })
    return unwrap(res)
  },

  async verifySignature(payload: { paymentId: string; subscriptionId: string; signature: string }) {
    const res = await api.post('/platform/billing/verify-signature', payload)
    return unwrap(res)
  },

  async changePlan(planId: number) {
    const res = await api.post('/platform/billing/change-plan', { planId })
    return unwrap(res)
  },

  async toggleAutoRenew(autoRenew: boolean) {
    const res = await api.post('/platform/billing/toggle-auto-renew', { autoRenew })
    return unwrap(res)
  },

  async getUserInvoices() {
    const res = await api.get('/platform/billing/invoices')
    return unwrap(res)
  },

  async validateCoupon(code: string, planId: number, amount: number) {
    const res = await api.post('/platform/billing/coupons/validate', { code, planId, amount })
    return unwrap(res)
  },
}
